/* ==========================================================================
   KLOKI – Back to School LP: chování (vanilla, bez závislostí)
   Vše řízené data-bts-* atributy. Init je idempotentní a spouští se znovu
   na shopify:section:load (Theme editor sekce překresluje).
   Stránka MUSÍ být použitelná i bez tohoto souboru (fail-open) – sync
   GitHub -> Shopify není atomický a šablona se umí propsat dřív než assety.
   Specifikace chování: BTS-LP-MIGRACE.md §4.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- analytika ----------------
     dataLayer: GTM je nasazený mimo theme -> pole jen doplňujeme, nikdy
     nepřepisujeme. PostHog: capture JEN po skutečném init (__loaded), tedy
     po souhlasu. Stub PostHogu si volání frontuje a po init by je odeslal
     dodatečně – to by poslalo i eventy zachycené PŘED souhlasem. */
  function track(event, payload) {
    if (!event) return;
    var data = payload || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data));
    if (typeof window.gtag === 'function') window.gtag('event', event, data);
    if (window.posthog && window.posthog.__loaded && typeof window.posthog.capture === 'function') {
      window.posthog.capture(event, data);
    }
  }
  function parseData(el, attr) {
    var raw = el.getAttribute(attr);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function initTracking(root) {
    root.querySelectorAll('[data-bts-track]').forEach(function (el) {
      if (el.__btsTrack) return; el.__btsTrack = true;
      el.addEventListener('click', function () {
        var d = parseData(el, 'data-bts-track');
        if (d) track(d.event, d.payload);
      });
    });
    root.querySelectorAll('[data-bts-view]').forEach(function (el) {
      if (el.__btsView) return; el.__btsView = true;
      var d = parseData(el, 'data-bts-view');
      if (!d) return;
      observeOnce(el, 0.3, function () { track(d.event, d.payload); });
    });
  }

  function observeOnce(el, ratio, cb) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.disconnect(); cb(); }
      });
    }, { threshold: ratio });
    io.observe(el);
  }

  /* ---------------- plynulý scroll na kotvy ----------------
     #balicky: scroll k nadpisu (ne k hornímu padding sekce).
     Desktop: odečíst sticky header (~68 px) + malá mezera.
     Mobil: header skrytý → stačí 5 px. */
  function stickyHeaderOffset() {
    var headerSec = document.querySelector('.shopify-section:has(.bts-header)');
    if (!headerSec) return 5;
    var pos = window.getComputedStyle(headerSec).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 5;
    var h = headerSec.getBoundingClientRect().height;
    return Math.round((h > 0 ? h : 68) + 12);
  }

  function initAnchors(root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      if (a.__btsAnchor) return; a.__btsAnchor = true;
      a.addEventListener('click', function (ev) {
        var id = a.getAttribute('href');
        if (!id || id === '#') return;
        var target;
        try { target = document.querySelector(id); } catch (e) { return; }
        if (!target) return;
        ev.preventDefault();
        var el = target;
        if (target.id === 'balicky') {
          el = target.querySelector('.bts-heading') || target.querySelector('h2') || target;
        }
        var y = el.getBoundingClientRect().top + window.pageYOffset - stickyHeaderOffset();
        window.scrollTo({ top: Math.max(0, y), behavior: REDUCED ? 'auto' : 'smooth' });
        history.replaceState(null, '', id);
      });
    });
  }

  /* ---------------- carousely (scroll-snap + tečky + autoplay) ---------------- */
  function initCarousels(root) {
    root.querySelectorAll('[data-bts-carousel]').forEach(function (wrap) {
      if (wrap.__btsCarousel) return; wrap.__btsCarousel = true;

      var track_ = wrap.querySelector('[data-bts-track]');
      if (!track_) return;
      var dotsWrap = wrap.querySelector('[data-bts-dots]');
      var prev = wrap.querySelector('[data-bts-prev]');
      var next = wrap.querySelector('[data-bts-next]');
      var autoplay = parseInt(wrap.getAttribute('data-bts-autoplay') || '0', 10);
      var initial = parseInt(wrap.getAttribute('data-bts-initial') || '0', 10);
      var paused = false, timer = null, interacted = false, lastWidth = window.innerWidth;

      function stride() {
        var items = track_.children;
        if (items.length < 2) return track_.clientWidth || 1;
        return (items[1].offsetLeft - items[0].offsetLeft) || 1;
      }
      function maxScroll() { return track_.scrollWidth - track_.clientWidth; }
      function pages() { return Math.max(1, Math.round(maxScroll() / stride()) + 1); }
      function index() { return Math.round(track_.scrollLeft / stride()); }

      function buildDots() {
        if (!dotsWrap) return;
        var total = pages();
        if (dotsWrap.children.length !== total) {
          dotsWrap.innerHTML = '';
          for (var i = 0; i < total; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'bts-dot';
            b.setAttribute('aria-label', (dotsWrap.getAttribute('data-bts-dot-label') || 'Slide') + ' ' + (i + 1));
            b.addEventListener('click', (function (n) {
              return function () { interacted = true; pauseFor(8000); goTo(n, true); };
            })(i));
            dotsWrap.appendChild(b);
          }
        }
        syncDots();
      }
      function syncDots() {
        if (!dotsWrap) return;
        var current = Math.min(index(), dotsWrap.children.length - 1);
        Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
          dot.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      }
      function goTo(i, smooth) {
        var left = Math.min(i * stride(), maxScroll());
        track_.scrollTo({ left: left, behavior: (smooth && !REDUCED) ? 'smooth' : 'auto' });
      }
      /* Vycentrování slidu (mobilní carousel balíčků startuje na doporučeném). */
      function center(i, smooth) {
        var el = track_.children[i];
        if (!el) return;
        var left = el.offsetLeft - (track_.clientWidth - el.clientWidth) / 2;
        track_.scrollTo({ left: Math.max(0, left), behavior: (smooth && !REDUCED) ? 'smooth' : 'auto' });
      }
      function step() {
        if (paused) return;
        var nextIndex = index() + 1;
        if (nextIndex * stride() > maxScroll() + 4) nextIndex = 0;
        goTo(nextIndex, true);
      }
      function pauseFor(ms) {
        paused = true;
        clearTimeout(wrap.__btsResume);
        wrap.__btsResume = setTimeout(function () { paused = false; }, ms);
      }

      track_.addEventListener('scroll', function () {
        clearTimeout(wrap.__btsScrollEnd);
        wrap.__btsScrollEnd = setTimeout(syncDots, 80);
      }, { passive: true });
      /* Interakce uživatele = konec automatického centrování (schválně NE
         event scroll – ten střílí i naše programové posuny). */
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (evName) {
        track_.addEventListener(evName, function () { interacted = true; pauseFor(8000); }, { passive: true });
      });
      wrap.addEventListener('mouseenter', function () { paused = true; });
      wrap.addEventListener('mouseleave', function () { paused = false; });
      wrap.addEventListener('focusin', function () { paused = true; });
      wrap.addEventListener('focusout', function () { paused = false; });

      if (prev) prev.addEventListener('click', function () { interacted = true; pauseFor(8000); goTo(Math.max(0, index() - 1), true); });
      if (next) next.addEventListener('click', function () { interacted = true; pauseFor(8000); goTo(index() + 1, true); });

      buildDots();
      /* Výchozí slide: hned + po layoutu + po 400 ms (dokreslení fotek),
         ale jen dokud si uživatel sám nezascrolloval. */
      if (initial > 0) {
        var recenter = function () { if (!interacted) { center(initial, false); syncDots(); } };
        recenter();
        requestAnimationFrame(recenter);
        setTimeout(recenter, 400);
      }
      if (autoplay > 0 && !REDUCED) timer = setInterval(step, autoplay);

      /* Reagujeme jen na změnu ŠÍŘKY – změna výšky je URL lišta na mobilu. */
      window.addEventListener('resize', function () {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        buildDots();
        if (initial > 0) center(initial, false);
      });

      wrap.__btsDestroy = function () { if (timer) clearInterval(timer); };
    });
  }

  /* ---------------- taby -> carousel (sekce funkcí) ---------------- */
  function initTabs(root) {
    root.querySelectorAll('[data-bts-tabs]').forEach(function (tabs) {
      if (tabs.__btsTabs) return; tabs.__btsTabs = true;
      var wrap = document.getElementById(tabs.getAttribute('data-bts-tabs'));
      if (!wrap) return;
      var track_ = wrap.querySelector('[data-bts-track]');
      if (!track_) return;
      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[data-bts-tab]'));

      function paint(i) {
        buttons.forEach(function (b, n) { b.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
        Array.prototype.forEach.call(track_.children, function (card, n) {
          card.classList.toggle('is-active', n === i);
        });
      }
      function activate(i) {
        paint(i);
        if (track_.scrollWidth > track_.clientWidth) {
          track_.scrollTo({ left: i * track_.clientWidth, behavior: REDUCED ? 'auto' : 'smooth' });
        }
      }
      buttons.forEach(function (b, i) { b.addEventListener('click', function () { activate(i); }); });
      /* Swipe na mobilu synchronizuje aktivní tab (React chování). */
      track_.addEventListener('scroll', function () {
        clearTimeout(tabs.__btsSync);
        tabs.__btsSync = setTimeout(function () {
          if (track_.scrollWidth <= track_.clientWidth) return;
          var i = Math.round(track_.scrollLeft / track_.clientWidth);
          paint(Math.max(0, Math.min(buttons.length - 1, i)));
        }, 80);
      }, { passive: true });
      paint(0);
    });
  }

  /* ---------------- FAQ: nativní <details>, JS jen dozavírá a měří ---------------- */
  function initFaq(root) {
    root.querySelectorAll('[data-bts-faq-group]').forEach(function (group) {
      group.querySelectorAll('details[data-bts-faq]').forEach(function (d) {
        if (d.__btsFaq) return; d.__btsFaq = true;
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          group.querySelectorAll('details[data-bts-faq][open]').forEach(function (other) {
            if (other !== d) other.open = false;
          });
          var q = d.getAttribute('data-bts-question');
          if (!q) {
            var s = d.querySelector('summary');
            q = s ? s.textContent.trim() : '';
          }
          track('back_to_school_faq_open', { question: q });
        });
      });
    });
  }

  /* ---------------- kopírování slevového kódu ---------------- */
  function initCopy(root) {
    root.querySelectorAll('[data-bts-copy]').forEach(function (el) {
      if (el.__btsCopy) return; el.__btsCopy = true;
      el.addEventListener('click', function () {
        var code = el.getAttribute('data-bts-copy');
        var done = el.getAttribute('data-bts-copied-label');
        var label = el.querySelector('[data-bts-copy-label]') || el;
        var original = label.textContent;
        var write = navigator.clipboard && navigator.clipboard.writeText
          ? navigator.clipboard.writeText(code)
          : Promise.reject();
        write.catch(function () {
          var ta = document.createElement('textarea');
          ta.value = code; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
        }).then(function () {
          if (done) { label.textContent = done; setTimeout(function () { label.textContent = original; }, 2000); }
          track('back_to_school_coupon_copy', {
            coupon_code: code,
            placement: el.getAttribute('data-bts-placement') || 'unknown'
          });
        });
      });
    });
  }

  /* ---------------- sticky mobilní CTA + odhalení CTA v hlavičce ---------------- */
  function initSticky(root) {
    root.querySelectorAll('[data-bts-sticky-cta]').forEach(function (bar) {
      if (bar.__btsSticky) return; bar.__btsSticky = true;
      var sel = bar.getAttribute('data-bts-trigger') || '#jak-pomahaji';
      var trigger = document.querySelector(sel);
      if (!trigger) return;
      var offers = document.getElementById('balicky');
      var ticking = false;
      function update() {
        ticking = false;
        var showAfter = trigger.getBoundingClientRect().top < window.innerHeight * 0.6;
        /* Po dojezdu na offer sekci sticky schovat (mobil). */
        var atOffers = false;
        if (offers) {
          var ot = offers.getBoundingClientRect().top;
          atOffers = ot < window.innerHeight * 0.4;
        }
        var visible = showAfter && !atOffers;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        bar.querySelectorAll('a,button').forEach(function (n) { n.tabIndex = visible ? 0 : -1; });
      }
      window.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(update);
      }, { passive: true });
      update();
    });

    root.querySelectorAll('[data-bts-header]').forEach(function (header) {
      if (header.__btsHeader) return; header.__btsHeader = true;
      var cta = header.querySelector('[data-bts-header-cta]');
      function reveal(on) {
        header.classList.toggle('is-revealed', on);
        if (cta) cta.setAttribute('aria-hidden', on ? 'false' : 'true');
      }
      var promo = document.getElementById('bts-promo-bar');
      if (!promo || !('IntersectionObserver' in window)) { reveal(true); return; }
      new IntersectionObserver(function (entries) {
        reveal(!entries[0].isIntersecting);
      }, { threshold: 0 }).observe(promo);
    });
  }

  /* ---------------- scroll-swap fotka (perspektivy) ----------------
     Výchozí = bez brýlí. Po scrollu (hornní hrana < 40 % vh) → s brýlemi.
     Obousměrně jako originál — při scrollu zpět zase bez brýlí. */
  function initSwap(root) {
    root.querySelectorAll('[data-bts-swap]').forEach(function (img) {
      if (img.__btsSwap) return; img.__btsSwap = true;
      var withGlasses = img.getAttribute('data-bts-swap-src');
      var withoutGlasses = img.getAttribute('src');
      if (!withGlasses || !withoutGlasses) return;
      var pre = new Image(); pre.src = withGlasses;
      function update() {
        var top = img.getBoundingClientRect().top;
        var threshold = window.innerHeight * 0.4;
        var next = top < threshold ? withGlasses : withoutGlasses;
        if (img.getAttribute('src') !== next) img.src = next;
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------------- automatická rotace fotek (karty balíčků) ---------------- */
  function initRotate(root) {
    root.querySelectorAll('[data-bts-rotate]').forEach(function (wrap) {
      if (wrap.__btsRotate || REDUCED) return; wrap.__btsRotate = true;
      var delay = parseInt(wrap.getAttribute('data-bts-rotate'), 10) || 4000;
      var slides = wrap.querySelectorAll('[data-bts-rotate-item]');
      if (slides.length < 2) return;
      var dots = wrap.querySelectorAll('[data-bts-rotate-dot]');
      var i = 0;
      function paintDots() {
        dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }
      paintDots();
      wrap.__btsRotateTimer = setInterval(function () {
        slides[i].style.opacity = '0';
        i = (i + 1) % slides.length;
        slides[i].style.opacity = '1';
        paintDots();
      }, delay);
    });
  }

  /* ---------------- videa učitelů ---------------- */
  function initVideos(root) {
    root.querySelectorAll('[data-bts-video]').forEach(function (card) {
      if (card.__btsVideo) return; card.__btsVideo = true;
      var video = card.querySelector('video');
      var play = card.querySelector('[data-bts-play]');
      var mute = card.querySelector('[data-bts-mute]');
      if (!video) return;

      if (play) play.addEventListener('click', function () {
        video.controls = true;
        video.muted = false;
        if (mute) syncMute();
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        play.style.display = 'none';
        track('back_to_school_teacher_video_play', { video_id: card.getAttribute('data-bts-video') || '' });
      });

      function syncMute() {
        if (!mute) return;
        mute.setAttribute('aria-label', video.muted
          ? (mute.getAttribute('data-bts-label-unmute') || 'Unmute')
          : (mute.getAttribute('data-bts-label-mute') || 'Mute'));
        mute.classList.toggle('is-muted', video.muted);
      }
      if (mute) {
        mute.addEventListener('click', function () {
          video.muted = !video.muted;
          syncMute();
        });
        syncMute();
      }
    });
  }

  /* ---------------- quick-add popup (karty balíčků) ----------------
     CTA karty nese data-bts-qa JSON: barva hodinek = dva PRODUKTY
     (černé/růžové), u MAX má produkt navíc varianty řemínku. Klik místo
     navigace otevře popup; bez JS odkaz naviguje postaru (fail-open).
     Po přidání: /cart/add.js (s kontrolou response.ok!), pak se POČKÁ na
     /discount/<kód> (jinak se drawer vykreslí bez slevy) a teprve potom se
     otevře nativní drawer přes KlokiCart (na BTS šabloně se nově renderuje). */
  var STRAP_COLORS = {
    'Černá': '#1d1d1d', 'Černé': '#1d1d1d',
    'Růžová': '#F2A0C4', 'Růžové': '#F2A0C4',
    'Modrá': '#33A3FF', 'Modré': '#33A3FF',
    'Zelená': '#26A455', 'Zelené': '#26A455',
    'Fialová': '#8B5CF6', 'Fialové': '#8B5CF6',
    'Oranžová': '#FF8A26', 'Oranžové': '#FF8A26',
    'Bílá': '#F4F4F4', 'Bílé': '#F4F4F4',
    'Žlutá': '#FFD43B', 'Žluté': '#FFD43B'
  };

  function initQuickAdd(root) {
    var popup = document.getElementById('bts-qa');
    if (!popup) return;

    var colorsWrap = popup.querySelector('[data-bts-qa-colors]');
    var strapGroup = popup.querySelector('[data-bts-qa-strap-group]');
    var strapsWrap = popup.querySelector('[data-bts-qa-straps]');
    var titleEl = popup.querySelector('#bts-qa-title');
    var priceEl = popup.querySelector('[data-bts-qa-price]');
    var codeEl = popup.querySelector('[data-bts-qa-code]');
    var errorEl = popup.querySelector('[data-bts-qa-error]');
    var addBtn = popup.querySelector('[data-bts-qa-add]');
    var codeTpl = popup.getAttribute('data-bts-qa-code-tpl') || '';

    var state = { data: null, color: null, variantId: null, opener: null };

    function selectableStraps(color) {
      /* Jediná varianta „Default Title" = produkt bez řemínků. */
      if (!color || color.variants.length < 2) return null;
      return color.variants;
    }

    function makeOpt(label, dotColor, imageUrl) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bts-qa__opt';
      if (imageUrl) {
        var img = document.createElement('img');
        img.className = 'bts-qa__thumb';
        img.src = imageUrl;
        img.alt = '';
        img.width = 28;
        img.height = 28;
        img.loading = 'lazy';
        b.appendChild(img);
      } else if (dotColor) {
        var dot = document.createElement('span');
        dot.className = 'bts-qa__dot';
        dot.style.backgroundColor = dotColor;
        b.appendChild(dot);
      }
      b.appendChild(document.createTextNode(label));
      return b;
    }

    function paintActive(wrap, activeEl) {
      Array.prototype.forEach.call(wrap.children, function (c) {
        c.classList.toggle('is-active', c === activeEl);
      });
    }

    function renderStraps() {
      var straps = selectableStraps(state.color);
      if (!straps) {
        strapGroup.hidden = true;
        var v = state.color && state.color.variants[0];
        state.variantId = v && v.available ? v.id : null;
        syncAdd();
        return;
      }
      strapGroup.hidden = false;
      strapsWrap.innerHTML = '';
      state.variantId = null;
      straps.forEach(function (v) {
        var b = makeOpt(v.title, STRAP_COLORS[v.title] || '#cfd8e3', v.image || '');
        if (!v.available) { b.disabled = true; }
        b.addEventListener('click', function () {
          state.variantId = v.id;
          paintActive(strapsWrap, b);
          syncAdd();
        });
        strapsWrap.appendChild(b);
        if (state.variantId === null && v.available) {
          state.variantId = v.id;
          b.classList.add('is-active');
        }
      });
      syncAdd();
    }

    function renderPrice() {
      if (priceEl) priceEl.textContent = state.color ? state.color.final : '';
      if (codeEl) {
        codeEl.textContent = state.data.code && codeTpl
          ? codeTpl.replace('@CODE@', state.data.code)
          : '';
      }
      /* Odkaz na detail vybrané barvy — přes /discount/, ať kupón nepropadne. */
      var detailEl = popup.querySelector('[data-bts-qa-detail]');
      if (detailEl) {
        var url = state.color && state.color.url;
        if (url && state.data.code) {
          detailEl.href = '/discount/' + encodeURIComponent(state.data.code) + '?redirect=' + encodeURIComponent(url);
        } else if (url) {
          detailEl.href = url;
        }
        detailEl.hidden = !url;
      }
    }

    function renderColors() {
      colorsWrap.innerHTML = '';
      state.data.colors.forEach(function (c, i) {
        var b = makeOpt(
          c.label,
          c.key === 'pink' ? '#F2A0C4' : '#1d1d1d',
          c.image || ''
        );
        b.addEventListener('click', function () {
          state.color = c;
          paintActive(colorsWrap, b);
          renderStraps();
          renderPrice();
        });
        colorsWrap.appendChild(b);
        if (i === 0) {
          state.color = c;
          b.classList.add('is-active');
        }
      });
    }

    function syncAdd() {
      if (addBtn) addBtn.disabled = !state.variantId;
    }

    function openPopup(data, opener) {
      state.data = data;
      state.opener = opener || null;
      if (titleEl) titleEl.textContent = data.name || '';
      var promptEl = popup.querySelector('[data-bts-qa-prompt]');
      if (promptEl) {
        var hasStraps = data.colors.some(function (c) { return c.variants.length > 1; });
        promptEl.textContent = promptEl.getAttribute(hasStraps ? 'data-bts-prompt-strap' : 'data-bts-prompt-color') || '';
      }
      if (errorEl) errorEl.hidden = true;
      if (addBtn) {
        addBtn.textContent = addBtn.getAttribute('data-bts-label-add') || addBtn.textContent;
      }
      renderColors();
      renderStraps();
      renderPrice();
      /* Na body: overlay pak jistě překryje sticky header i sticky CTA. */
      if (popup.parentElement !== document.body) document.body.appendChild(popup);
      popup.hidden = false;
      document.documentElement.classList.add('bts-qa-open');
      var closeBtn = popup.querySelector('.bts-qa__close');
      if (closeBtn) closeBtn.focus();
    }

    function closePopup() {
      popup.hidden = true;
      document.documentElement.classList.remove('bts-qa-open');
      if (state.opener && state.opener.focus) state.opener.focus();
    }

    if (!popup.__btsQa) {
      popup.__btsQa = true;

      popup.querySelectorAll('[data-bts-qa-close]').forEach(function (el) {
        el.addEventListener('click', closePopup);
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && !popup.hidden) closePopup();
      });

      if (addBtn) addBtn.addEventListener('click', function () {
        if (!state.variantId || !state.data) return;
        if (errorEl) errorEl.hidden = true;
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-bts-label-adding') || addBtn.textContent;

        fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: state.variantId, quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function () {
            track('back_to_school_add_to_cart', {
              bundle_name: state.data.track,
              color: state.color ? state.color.key : '',
              variant_id: state.variantId,
              discount_code: state.data.code || '',
              placement: 'quick-add'
            });
            /* Kupón MUSÍ doběhnout DŘÍV, než se vykreslí drawer. Dokud se
               nečekalo, drawer se stihl vyrenderovat bez slevy a zákazník
               v košíku viděl vyšší cenu — sleva naskočila až po ručním
               obnovení stránky. Změřeno: prohrával to i na desktopu.

               ?redirect= míří na cart.js, ne na výchozí cíl: bez něj
               /discount/<kód> přesměruje na homepage a fetch ji celou stáhne
               (naměřeno 1,65 MB a ~1 000 ms). S cart.js jsou to 3 kB a ~650 ms,
               což je na mobilních datech rozdíl mezi „chvilku to trvá" a
               „zákazník mezitím odejde". */
            var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
            var kupon = Promise.resolve();
            if (state.data.code) {
              /* STROP 2,5 s. `fetch` sám o sobě netimeoutuje, takže na mrtvém
                 mobilním připojení (typicky prohlížeč v Instagramu) by tenhle
                 požadavek visel donekonečna — a protože se na něj čeká, zůstal
                 by zákazník s tlačítkem „Přidávám…" a bez košíku. Po vypršení
                 se drawer otevře tak jako tak; nejhorší případ je pak původní
                 chování (cena bez slevy), ne zaseknuté tlačítko. */
              kupon = Promise.race([
                fetch('/discount/' + encodeURIComponent(state.data.code) +
                      '?redirect=' + encodeURIComponent(cartUrl + '.js'),
                      { credentials: 'same-origin' }).catch(function () {}),
                new Promise(function (hotovo) { setTimeout(hotovo, 2500); })
              ]);
            }

            /* Tlačítko zůstane ve stavu „Přidávám…", dokud se drawer neotevře —
               je to pravdivá zpětná vazba, pořád se pracuje. */
            return kupon.then(function () {
              addBtn.disabled = false;
              addBtn.textContent = addBtn.getAttribute('data-bts-label-add') || addBtn.textContent;
              closePopup();
              if (window.KlokiCart) {
                window.KlokiCart.invalidateCart();
                window.KlokiCart.open();
              } else {
                window.location = cartUrl;
              }
            });
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.getAttribute('data-bts-label-add') || addBtn.textContent;
            if (errorEl) errorEl.hidden = false;
          });
      });
    }

    root.querySelectorAll('[data-bts-qa]').forEach(function (el) {
      if (el.__btsQaTrigger) return; el.__btsQaTrigger = true;
      el.addEventListener('click', function (ev) {
        var data = parseData(el, 'data-bts-qa');
        if (!data || !data.colors || !data.colors.length) return; /* fail-open: nech odkaz navigovat */
        ev.preventDefault();
        openPopup(data, el);
      });
    });

    /* Mobil: celá karta otevře popup. Scroll (posun > 12 px) / dlouhý stisk
       / klik na odkaz·tlačítko uvnitř se ignorují — bez omylů při swipe. */
    root.querySelectorAll('.bts-bundle[data-bts-qa-card]').forEach(function (card) {
      if (card.__btsQaCard) return; card.__btsQaCard = true;
      var cta = card.querySelector('[data-bts-qa]');
      if (!cta) return;
      var start = null;
      function isMobile() {
        return window.matchMedia('(max-width: 1023px)').matches;
      }
      card.addEventListener('pointerdown', function (ev) {
        if (!isMobile()) return;
        if (ev.target.closest('a, button')) { start = null; return; }
        start = { x: ev.clientX, y: ev.clientY, t: Date.now() };
      }, { passive: true });
      card.addEventListener('pointerup', function (ev) {
        if (!start || !isMobile()) { start = null; return; }
        var dx = Math.abs(ev.clientX - start.x);
        var dy = Math.abs(ev.clientY - start.y);
        var dt = Date.now() - start.t;
        start = null;
        if (dx > 12 || dy > 12 || dt > 450) return;
        if (ev.target.closest('a, button')) return;
        var data = parseData(cta, 'data-bts-qa');
        if (!data || !data.colors || !data.colors.length) return;
        ev.preventDefault();
        openPopup(data, cta);
      });
      card.addEventListener('pointercancel', function () { start = null; });
      card.addEventListener('pointerleave', function () { start = null; });
    });
  }

  /* ---------------- boot ---------------- */
  function init(root) {
    root = root || document;
    initTracking(root);
    initAnchors(root);
    initCarousels(root);
    initTabs(root);
    initFaq(root);
    initCopy(root);
    initSticky(root);
    initSwap(root);
    initRotate(root);
    initVideos(root);
    initQuickAdd(root);
  }

  function boot() {
    init(document);
    track('back_to_school_view', {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor překresluje sekce. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-bts-carousel]').forEach(function (w) {
      if (w.__btsDestroy) w.__btsDestroy();
    });
    e.target.querySelectorAll('[data-bts-rotate]').forEach(function (w) {
      if (w.__btsRotateTimer) clearInterval(w.__btsRotateTimer);
    });
  });

  window.BTS = { init: init, track: track };
})();
